const allPage = require('../../pages.js')
const pages = Object.keys(allPage).reduce((previous, current) => {
  if (!previous[current]) {
    previous[current] = allPage[current].filename
  }
  return previous
}, {})

export default pages
